module.exports = __webpack_public_path__ + "static/media/the_carbon_challenge-desktop.4f613429.jpg";